import Billings from "@/models/loyaltyPanel/subscriptions/Billings";

export default {

    namespaced: true,

    actions: {
        async updateStatus({commit}, payload) {
            try {
                commit("setLoading", true, {root: true});

                let {data} = await Billings.updateStatus(payload)

                commit("setLoading", false, {root: true});

                return data

            } catch (ex) {
                commit("setLoading", false, {root: true});
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    {root: true}
                );
            }
        },
        async notifyBilling({commit}, payload) {
            try {
                commit("setLoading", true, {root: true});

                let {data} = await Billings.notifyBilling(payload)

                commit("setLoading", false, {root: true});

                return data

            } catch (ex) {
                commit("setLoading", false, {root: true});
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    {root: true}
                );
                return ex.response.data

            }
        },
        async getBillings({commit}, {id, page}) {
            try {
                commit("setLoading", true, {root: true});

                let {data} = await Billings.getBillings(id, page)
                
                commit("setLoading", false, {root: true});

                return data

            } catch (ex) {
                commit("setLoading", false, {root: true});
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    {root: true}
                );
                return ex.response.data

            }
        },
    }
}